import React from "react"
import "./Paginator.css"

interface PaginatorProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const Paginator: React.FC<PaginatorProps> = ({ currentPage, totalPages, onPageChange }) => {
  const range = 2 // 現在のページの前後に表示する範囲

  const generatePageNumbers = () => {
    const pages: (number | "...")[] = []

    // 最初のページ
    if (currentPage > range + 1) {
      pages.push(1, "...")
    }

    // 現在のページの範囲
    for (let i = Math.max(1, currentPage - range); i <= Math.min(totalPages, currentPage + range); i++) {
      pages.push(i)
    }

    // 最後のページ
    if (currentPage < totalPages - range) {
      pages.push("...", totalPages)
    }

    return pages
  }

  const pageNumbers = generatePageNumbers()

  return (
    <div className="pagination-container">
      {/* 最初のページ */}
      <button onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        &lt;&lt;
      </button>

      {/* 前のページ */}
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        &lt;
      </button>

      {/* ページ番号 */}
      {pageNumbers.map((page, index) =>
        typeof page === "number" ? (
          <button key={page} className={currentPage === page ? "active" : ""} onClick={() => onPageChange(page)}>
            {page}
          </button>
        ) : (
          <span key={`ellipsis-${index}`} className="ellipsis">
            ...
          </span>
        )
      )}

      {/* 次のページ */}
      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        &gt;
      </button>

      {/* 最後のページ */}
      <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
        &gt;&gt;
      </button>
    </div>
  )
}

export default Paginator
